import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetAISessionByIdQuery } from "../../ai-sessions.service";
import AISessionDetails from "../../components/ai-session-details";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

const AISessionDetailsPage = () => {
  const { aiSessionId } = useParams<{ aiSessionId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToAISessions = appendSearchToPath("/ai-sessions", location.search);
  const { data: aiSession, isLoading, isError } = useGetAISessionByIdQuery(aiSessionId || "");

  if (isLoading) return <div className="p-6">Loading...</div>;
  if (isError || !aiSession) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
            <h2 className="text-2xl font-bold text-red-800 mb-4">AI Session Not Found</h2>
            <button onClick={() => navigate(backToAISessions)} className="px-6 py-3 bg-red-600 text-white rounded-lg">
              Back to AI Sessions
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <AISessionDetails aiSession={aiSession} onBack={() => navigate(backToAISessions)} />;
};

export default AISessionDetailsPage;
